import { API_ROOT } from '../../../../config';
import { ssFetchJSON } from '../../../../modules/ssFetch';

/**
 * ProviderClientCommSettingsView
 * GET: api/v1/provider/{providerId}/settings/communication/client.json
 */
export type ClientCommSettings = {
  auto_reminder_days: number;
  birthday_promo_which: null;
  default_custom_sms_text: string;
  enable_provider_client_appointment_modification_email: boolean;
  enabled_auto_followups: boolean;
  enabled_auto_recalls: boolean;
  enabled_auto_reminders: boolean;
  enabled_birthday_promo: boolean;
  extra_settings__birthday_promo_amount: null;
  extra_settings__birthday_promo_dollars: null;
  extra_settings__birthday_promo_free_service: null;
  extra_settings__custom_sms_text: '';
};

/**
 * ProviderCommSettingsSerializer
 * POST: api/v1/provider/{providerId}/settings/communication/client.json
 */
export type ClientCommSettingsSave = {
  enable_provider_client_appointment_modification_email: boolean;
  enabled_auto_followups: boolean;
  enabled_auto_reminders: boolean;
};

export function getClientCommSettings(providerId: number | string): Promise<ClientCommSettings> {
  const url = new URL(`${API_ROOT}/api/v1/provider/${providerId}/settings/communication/client.json`);
  return ssFetchJSON(url.toString());
}

export function saveClientCommSettings(providerId: number | string, data: ClientCommSettingsSave) {
  const url = new URL(`${API_ROOT}/api/v1/provider/${providerId}/settings/communication/client.json`);
  return ssFetchJSON(url.toString(), {
    method: 'POST',
    form: data,
  });
}
